import { Popover } from "antd"
import { InfoIcon } from "components/ui/icons/info/InfoIcon"
import style from "./ModelNumberOrderTip.module.scss"

const {
	trigger,
	popover,
	example,
	exampleCaption,
	chip,
	chipPicked,
	chipFits,
	legend,
	rows,
	row,
	rowPicked,
	rowFits,
	rank,
	verdict,
} = style

type Props = {
	// `tags` for a select's numbered tags (left to right), `list` for a priority-ordered table.
	variant?: "tags" | "list"
}

const EXAMPLE = [
	{ n: 1, name: "BC24-2D" },
	{ n: 2, name: "BC24-2DR" },
	{ n: 3, name: "BC27-2D", picked: true },
	{ n: 4, name: "BC30-2D" },
	{ n: 5, name: "BC36-2D", fits: true },
]

const TagsContent = () => (
	<>
		<p>
			Processing checks model numbers in this order. If several match the detected object, it picks the first of them.
		</p>
		<div className={example}>
			<span className={exampleCaption}>Example: the detected object fits 3 and 5</span>
			{EXAMPLE.map(({ n, name, picked, fits }) => (
				<span key={n} className={`${chip} ${picked ? chipPicked : ""} ${fits ? chipFits : ""}`}>
					{n} {name}
				</span>
			))}
			<span className={legend}>→ BC27-2D is picked</span>
		</div>
	</>
)

const ListContent = () => (
	<>
		<p>
			Processing checks model numbers from top to bottom. If several match the detected object, it picks the one highest
			in this list.
		</p>
		<div className={`${example} ${rows}`}>
			<span className={exampleCaption}>Example: the detected object fits model numbers 3 and 5</span>
			{EXAMPLE.map(({ n, name, picked, fits }) => (
				<span key={n} className={`${row} ${picked ? rowPicked : ""} ${fits ? rowFits : ""}`}>
					<span className={rank}>{n}</span>
					<span>{name}</span>
					<span className={verdict}>{picked ? "fits · picked" : fits ? "fits" : "doesn’t fit"}</span>
				</span>
			))}
		</div>
	</>
)

// The (i) button that explains what model number order means (REQ-457..459).
export const ModelNumberOrderTip = ({ variant = "tags" }: Props) => (
	<Popover
		content={
			<div className={popover} data-testid="model-number-order-popover">
				{variant === "list" ? <ListContent /> : <TagsContent />}
			</div>
		}
		trigger={["hover", "focus"]}
		placement="right"
	>
		<button type="button" className={trigger} aria-label="What does the model number order mean?">
			<InfoIcon />
		</button>
	</Popover>
)
